import React from 'react';
import Script from 'next/script';

import { IOutgrowFields } from '@/types/contentful';

export default function GreetBar({ code }: Partial<IOutgrowFields>) {
  return code ? (
    <>
      <div
        dangerouslySetInnerHTML={{ __html: code || '' }}
        data-testid="outgrow-greet-bar"
      />
      <Script
        id="outgrow-greet-bar"
        strategy="afterInteractive"
        src="https://dyv6f9ner1ir9.cloudfront.net/assets/js/og_greet_bar.js"
      />
    </>
  ) : null;
}
